// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
/**
 * Reducers for handling scenes-related state updates.
 *
 */

export const filterScenesState = (state, filteredScenes) => {
  state.filterScenes.scenes = filteredScenes;
};

export const localFilterScenesState = (state, updatedScenes) => {
  const { scenes, providers, filterValue, sortOrder } = updatedScenes;
  state.filterScenes = {
    scenes,
    providers,
    title: filterValue,
    sortOrder: sortOrder || 'desc',
  };
};

// Create, Update, Delete scene keywords
export const addKeywordToSceneState = (state, keyword) => {
  const sceneIndex = state.scenes.findIndex(scene => scene.scene_id === keyword.scene_id);
  if (sceneIndex !== -1) {
    state.scenes[sceneIndex] = {
      ...state.scenes[sceneIndex],
      keywords: [...(state.scenes[sceneIndex].keywords || []), keyword],
    };
  }
  if (state.selectedScene?.scene_id === keyword.scene_id) {
    state.selectedScene = {
      ...state.selectedScene,
      keywords: [...(state.selectedScene?.keywords || []), keyword],
    };
  }
};

export const deleteKeywordFromSceneState = (state, keyword) => {
  const { keywordId, sceneId } = keyword;
  const sceneIndex = state.scenes.findIndex(scene => scene?.scene_uuid === sceneId);
  if (sceneIndex !== -1) {
    state.scenes[sceneIndex] = {
      ...state.scenes[sceneIndex],
      keywords:
        state.scenes[sceneIndex].keywords?.filter(
          keyword => keyword?.keyword?.keyword_uuid !== keywordId
        ) || [],
    };
  }
  if (state.selectedScene?.scene_uuid === sceneId) {
    state.selectedScene = {
      ...state.selectedScene,
      keywords: state.selectedScene?.keywords?.filter(
        keyword => keyword?.keyword?.keyword_uuid !== keywordId
      ),
    };
  }
};
